module.exports = __webpack_public_path__ + "media/images/icon-workbook-0b931361.png";